import React, { history, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import GoogleSignInButton from "./GoogleSignInButton";
import { useLocation } from "react-router-dom";
import { getCookie, setCookie, logout } from "../Utils/Cookie";
function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [protectd, setProtectd] = React.useState(
    window.location.pathname === "/library/" ? true : false
  );
  const [auth, setAuth] = React.useState(false);
  const navigate = useNavigate(); // React Router's navigation function
  const location = useLocation();

  useEffect(() => {
    // This effect runs every time the URL path changes
    //console.log("path changed to:", location.pathname);
    setProtectd(
      window.location.pathname === "/library/" ||
        window.location.pathname === "/library"
        ? true
        : false
    );
    setAuth(getCookie("kungfu") ? true : false);
  }, [location]);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };
  function logoutAndReload() {
    logout();
    window.location.reload();
  }
  function handleSignInSuccess(token) {
    //console.log("handleSignInSuccess", token);
    setCookie("kungfu", token, 30);
    window.location.reload();
  }
  return (
    <nav className="navbar">
      <div
        className="nav-logo"
        onClick={() => {
          navigate("/"); // Correctly navigate to the home route
        }}
      >
        {" "}
        <img src="/wushu.png" alt="wu" style={{ maxWidth: "64px" }}></img>{" "}
      </div>{" "}
      <button className="nav-toggle" onClick={toggleNav}>
        &#9776; {/* Hamburger icon */}
      </button>
      {/* 
        Use NavLink for each route.
        onClick={() => setIsOpen(false)} closes the menu on mobile after clicking a link.
      */}
      <ul className={isOpen ? "nav-links open" : "nav-links"}>
        <li>
          <NavLink to="/" onClick={() => setIsOpen(false)} end>
            home
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" onClick={() => setIsOpen(false)}>
            about
          </NavLink>
        </li>
        <li>
          <NavLink to="/classes" onClick={() => setIsOpen(false)}>
            classes
          </NavLink>
        </li>
        <li>
          <NavLink to="/systems" onClick={() => setIsOpen(false)}>
            systems
          </NavLink>
        </li>
        <li>
          <NavLink to="/resources" onClick={() => setIsOpen(false)}>
            info
          </NavLink>
        </li>
        {/* <li>
          <NavLink to="/discuss" onClick={() => setIsOpen(false)}>
            discuss
          </NavLink>
        </li> */}
        {/* {auth ? (
          <li>
            <NavLink to="/library/" onClick={() => setIsOpen(false)}>
              library
            </NavLink>
          </li>
        ) : (
          ""
        )} */}

        {auth ? (
          <button onClick={logoutAndReload}>logout</button>
        ) : (
          <GoogleSignInButton onSignInSuccess={handleSignInSuccess} />
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
